module.exports = __webpack_public_path__ + "img/action-icon-android.58b48c84.png";